module.exports = __webpack_public_path__ + "images/questions/qa_balloon_orange_01_f140d3ad6e4d5c64b10647a057e131a9.png";